import axios from 'axios';
import { ElMessage } from 'element-plus';
import { AUTH_SESSION_EXPIRED_EVENT, isPasswordChangeResponse, isSessionExpiredResponse, parseJsonBlobResponse, shouldRejectPasswordChangeResponse, PASSWORD_CHANGE_EVENT } from '@/util/passwordSecurity';

function notifyPasswordChange(response) {
    window.dispatchEvent(new CustomEvent(PASSWORD_CHANGE_EVENT, { detail: response.data || {} }));
}

function notifySessionExpired(response) {
    if (!localStorage.getItem('accessToken')) return;
    localStorage.removeItem('accessToken');
    window.dispatchEvent(new CustomEvent(AUTH_SESSION_EXPIRED_EVENT, { detail: response || {} }));
}

const service = axios.create({
    baseURL: '/api',
    timeout: 60000
});

const resDef = {
    code: 0,
    msg: '接口请求出错',
    data: {}
};

service.interceptors.request.use((config) => {
    const token = localStorage.getItem('accessToken');
    if (token && !config.skipAuthorization) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    console.error(error);
    return Promise.resolve(resDef);
});

service.interceptors.response.use(async (rawResponse) => {
    const response = await parseJsonBlobResponse(rawResponse);
    if (isPasswordChangeResponse(response.data)) {
        notifyPasswordChange(response.data);
        if (shouldRejectPasswordChangeResponse(response)) {
            throw new Error(response.data.msg || '请先修改密码后继续使用');
        }
        return response.data;
    }
    if (isSessionExpiredResponse(response.data)) {
        notifySessionExpired(response.data);
        return response.data;
    }
    // 二进制文件响应直接返回，不做 JSON 解析
    if (response.config.responseType === 'blob') {
        return response;
    }
    if (response.data.code !== 200 && !response.config.silentError && !response.config.url.includes('/auth/userInfo')) {
        ElMessage.error(response.data.msg);
    }
    return response.data;
}, async (error) => {
    if (error.config?.silentError) {
        return error.response?.data || resDef;
    }
    const parsedResponse = await parseJsonBlobResponse(error.response);
    if (isPasswordChangeResponse(parsedResponse?.data)) {
        notifyPasswordChange(parsedResponse.data);
        if (shouldRejectPasswordChangeResponse(parsedResponse)) {
            throw new Error(parsedResponse.data.msg || '请先修改密码后继续使用');
        }
        return parsedResponse.data;
    }
    if (error.response?.status === 401 || isSessionExpiredResponse(parsedResponse?.data)) {
        notifySessionExpired(parsedResponse?.data || { code: error.response?.status });
        return parsedResponse?.data || resDef;
    }
    console.error('请求错误:', error);
    let errorMsg = '请求失败';

    if (error.response) {
        const { status, data } = error.response;
        switch (status) {
            case 403:
                errorMsg = '没有权限访问该资源';
                break;
            case 404:
                errorMsg = '请求的资源不存在';
                break;
            case 500:
                errorMsg = '服务器内部错误';
                break;
            default:
                errorMsg = data?.msg || `请求错误，状态码: ${status}`;
        }
    } else if (error.request) {
        errorMsg = '网络错误，没有收到响应';
    } else {
        errorMsg = error?.message || '请求配置错误';
    }

    ElMessage.error(errorMsg);
    return Promise.resolve(resDef);
});

export default service;
